module.exports = __webpack_public_path__ + "static/media/dishant.1c96bda0.jpeg";